import React from 'react'
import classes from './SlotList.module.sass'
import { SlotItem } from './components/SlotItem'
import { SlotItemInterface } from '../../../../common/types/interfaces'
import { SkeletonLoader } from '../../../../common/components/skeletonLoader/SkeletonLoader'

type Props = {
  list: SlotItemInterface[]
  toggleSelected: (item: SlotItemInterface) => void
  loading: boolean
}

export const SlotList = ({ list, toggleSelected, loading }: Props) => {
  if (loading)
    return (
      <div className={classes.Container}>
        <SkeletonLoader count={1} style={{}} className="CardSlot" />
        <SkeletonLoader count={1} style={{}} className="CardSlot" />
        <SkeletonLoader count={1} style={{}} className="CardSlot" />
        <SkeletonLoader count={1} style={{}} className="CardSlot" />
        <SkeletonLoader count={1} style={{}} className="CardSlot" />
        <SkeletonLoader count={1} style={{}} className="CardSlot" />
        <SkeletonLoader count={1} style={{}} className="CardSlot" />
        <SkeletonLoader count={1} style={{}} className="CardSlot" />
      </div>
    )
  return (
    <div className={classes.Container}>
      {list.map((el) => (
        <SlotItem item={el} key={el.id} toggleSelected={toggleSelected} />
      ))}
    </div>
  )
}
